import { Typography } from '@/components/app'
import { Cards, OrderTracking, Stack, TrendUp } from '../icons/customIcons'
import { SectionTitle } from './SectionTitle'
import { motion } from 'framer-motion'
import { fadeLeft, fadeRight, fadeUp, staggerContainer, viewportOnce } from '@/lib/animations'

export function AboutAppSection() {
  const features = [
    {
      icon: <Stack />,
      text: 'Browse thousands of jewellery designs',
    },
    {
      icon: <TrendUp />,
      text: 'Real-time gold and silver price updates',
    },
    {
      icon: <Cards />,
      text: 'Secure online payments',
    },
    {
      icon: <OrderTracking />,
      text: 'Easy order tracking',
    },
  ]

  return (
    <section id="about" className="py-6 md:py-10 lg:py-12">
      <div className="wrapper">
        <motion.div
          className="mb-4 md:mb-6"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          <SectionTitle
            badge="ABOUT THE APP"
            title="Your Personal Jewellery Shopping Assistant"
          />
        </motion.div>

        <div className="clear-both">
          {/* Left Image */}
          <motion.div
            className="w-full md:w-[50%] md:pr-8 md:pb-3 pb-6 md:float-left"
            variants={fadeLeft}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
          >
            <div className="flex items-center justify-center order-2 md:order-1">
              <div style={{ boxShadow: '5px 4px 34px 0px #00000014' }}>
                <div className="md:rounded-[24px] rounded-xl overflow-hidden">
                  <img src="/images/about-app-section-img.webp" alt="hero" className="w-auto h-auto object-contain" />
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Content */}
          <motion.div
            className="w-full"
            variants={fadeRight}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
          >
            <div className="space-y-2">
              <div>
                <Typography>
                  Our jewellery app makes it easy to explore, compare, and purchase beautiful gold and silver jewellery from anywhere. Whether you're looking for daily wear or special occasion pieces, our mobile platform offers a seamless shopping experience.
                </Typography>
              </div>
              <motion.div
                className="gap-4 pt-4 overflow-hidden grid lg:w-auto w-full"
                style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(min(400px, 100%), 1fr))' }}
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={viewportOnce}
              >
                {features.map((feature, index) => (
                  <motion.div
                    key={index}
                    variants={fadeUp}
                    className="flex items-center gap-3"
                    whileHover={{ x: 4, transition: { duration: 0.2 } }}
                  >
                    <div className="w-12 h-12 border rounded-[12px] border-border-light flex items-center justify-center text-black">
                      {feature.icon}
                    </div>
                    <Typography variant="body2" className="text-foreground">
                      {feature.text}
                    </Typography>
                  </motion.div>
                ))}
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
